<template lang="pug">
  #app
    template(v-if="!this.$route.path.includes('login')")
      header-content
      div.flex-container
        nav-content
        ods-main
          ods-scrollbar(wrapClass="ods-scrollbar--main-content")
            main-dashboard
    template(v-else)
      transition(name='fade')
        router-view
</template>

<script>
import HeaderContent from '@/components/header/HeaderContent'
import NavContent from '@/components/nav/NavContent'
import MainDashboard from '@/views/mainDashboard'

export default {
  name: 'App',
  components: {
    HeaderContent,
    NavContent,
    MainDashboard
  }
}
</script>

<style lang="scss">

  html, body {
    font-family: 'Soho', Helvetica, Arial, sans-serif!important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-kerning: none;
    .ods-scrollbar--main-content {
      height: $--main-content-height;
      -ms-overflow-style: -ms-autohiding-scrollbar;
      //padding: 24px;
      box-sizing: border-box;
    }
  }
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
  /* Avoid appearing horizontal scroll bar in main. */
  .ods-main {
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
    background: #f5f7f8;
  }
  .ods-menu {
    z-index: 99;
  }
  /* Hide menu default scroll bar in Chrome and Safari. */
  .ods-menu::-webkit-scrollbar {
    display: none;
  }
  /* Hide table default scroll bar in Chrome and Safari. */
  .ods-table__body-wrapper::-webkit-scrollbar {
    display: none;
  }

  .maxSizeMain{
    height: calc(100vh - 64px);
  }
  /* TEMPORAL */
  .sc-card--without-shadow{
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05) !important;
  }
  .ods-loading-mask{
    z-index: 1000;
  }

  .ods-scrollbar__bar {
    opacity: 1;
  }

  .kpi_circle .symbol, .unitChart {
    text-transform: initial;
  }
  .ods-dialog {
    .sc-card{
      &__header{
        &__inner{
          border-bottom: 1px solid $--color-grey-light;
        }
      }
    }
  }
  .sc-kpi__tooltip {
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue